(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["br-craft-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('br-craft-video'))customElements.define('br-craft-video',class extends HTMLElement{connectedCallback(){this.querySelector('button')?.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src=this.dataset.host==='youtube'?'https://www.youtube-nocookie.com/embed/'+encodeURIComponent(this.dataset.id)+'?autoplay=1':'https://player.vimeo.com/video/'+encodeURIComponent(this.dataset.id)+'?autoplay=1';frame.title=this.dataset.title;frame.allow='autoplay; fullscreen; picture-in-picture';frame.allowFullscreen=true;frame.style.border='0';this.replaceChildren(frame)},{once:true})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-event-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('br-event-bar')) {
  customElements.define('br-event-bar', class extends HTMLElement {
    connectedCallback() {
      const parse = (value) => {
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec((value || '').trim());
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, offset] = match;
        const days = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
        if (+year < 1000 || +month < 1 || +month > 12 || +day < 1 || +day > days || +hour > 23 || +minute > 59 || +second > 59) return NaN;
        if (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4) > 59 || (+offset.slice(1, 3) === 14 && +offset.slice(4) !== 0))) return NaN;
        return Date.parse(match[0]);
      };
      const start = parse(this.dataset.start);
      const end = parse(this.dataset.end);
      const valid = Number.isFinite(start) && Number.isFinite(end) && start < end;
      this.check = () => {
        const now = Date.now();
        this.hidden = !(valid && now >= start && now < end);
      };
      this.check();
      this.timer = setInterval(this.check, 1000);
      document.addEventListener('visibilitychange', this.check);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.check);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-flag-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('br-flag-editorial')) customElements.define('br-flag-editorial', class extends HTMLElement {
  connectedCallback() {
    if (this.controller || !this.querySelector('[data-variants]')) return;
    this.controller = new AbortController();
    const on = (el, event, fn) => el.addEventListener(event, fn, {signal:this.controller.signal});
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const select = this.querySelector('select[name="id"]');
    const form = this.querySelector('form');
    const photo = this.querySelector('.bf-main-photo');
    const showPhoto = (src, alt) => { if (!photo) return; photo.removeAttribute('srcset'); photo.src = src; photo.alt = alt || photo.alt; this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.photo === src))); };
    const update = (id, writeURL = true) => {
      const v = variants.find(x => String(x.id) === String(id));
      if (!v) return;
      select.value = String(v.id);
      this.querySelectorAll('.bf-size-card input').forEach(x => x.checked = x.value === String(v.id));
      this.querySelectorAll('[data-price],[data-sticky-price]').forEach(x => x.textContent = v.price);
      this.querySelectorAll('[data-choice],[data-sticky-choice]').forEach(x => x.textContent = v.title);
      const compare = this.querySelector('[data-compare]'); compare.hidden = !v.compare; compare.textContent = v.compare || '';
      this.querySelectorAll('[data-add]').forEach(b => { b.disabled = !v.available; b.firstElementChild.textContent = v.available ? this.dataset.addLabel : this.dataset.soldLabel; });
      const qty = this.querySelector('[name="quantity"]'); qty.min = v.min; qty.step = v.step;
      if (v.max !== null) qty.max = v.max; else qty.removeAttribute('max');
      const n = Number(qty.value); if (!Number.isInteger(n) || n < v.min || (v.max !== null && n > v.max) || (n - v.min) % v.step) qty.value = v.min;
      this.querySelectorAll('[data-style-handle]').forEach(link => {
        const map = JSON.parse(this.querySelector('[data-style-map="'+link.dataset.styleHandle+'"]').textContent);
        const match = map.find(x => x.size === v.size);
        const url = new URL(link.href, location.origin);
        if (match) url.searchParams.set('variant', match.id); else url.searchParams.delete('variant');
        url.searchParams.set('view','flag-editorial');
        const preview = new URL(location.href).searchParams.get('preview_theme_id'); if(preview) url.searchParams.set('preview_theme_id',preview);
        link.href = url.toString();
      });
      if (v.image) showPhoto(v.image);
      this.querySelector('[data-status]').textContent = v.title + '. ' + v.price + '. ' + (v.available ? this.dataset.addLabel : this.dataset.soldLabel);
      if (writeURL) { const url = new URL(location.href); url.searchParams.set('variant',v.id); history.replaceState({},'',url); }
    };
    this.querySelector('.bf-size-grid').hidden = false; select.hidden = true; this.querySelector('.bf-fallback-label').hidden = true;
    this.querySelectorAll('.bf-size-card input').forEach(x => on(x,'change',()=>update(x.value)));
    on(select,'change',()=>update(select.value));
    this.querySelectorAll('[data-photo]').forEach(b => on(b,'click',()=>showPhoto(b.dataset.photo,b.dataset.alt)));
    let submitting = false;
    on(form,'submit',e => { const v = variants.find(x => String(x.id) === select.value); if(submitting || !v?.available){e.preventDefault();return;} submitting=true; this.querySelectorAll('[data-add]').forEach(b=>{b.firstElementChild.textContent=this.dataset.addingLabel;}); });
    on(window,'pageshow',()=>{submitting=false;update(select.value,false);});
    on(window,'popstate',()=>update(new URL(location.href).searchParams.get('variant') || select.value,false));
    const sticky = this.querySelector('.bf-sticky');
    if ('IntersectionObserver' in window) {this.observer = new IntersectionObserver(entries=>{sticky.hidden=entries[0].boundingClientRect.bottom>0;},{threshold:0});this.observer.observe(this.querySelector('.bf-buy'));}
    update(select.value,false);
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.controller=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-size-visualizer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('br-size-preview')){customElements.define('br-size-preview',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',e=>{const button=e.target.closest('button[data-size]');if(!button)return;this.querySelectorAll('[data-size]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));this.querySelectorAll('[data-panel]').forEach(x=>x.hidden=x.dataset.panel!==button.dataset.size)});this.addEventListener('shopify:block:select',e=>{this.querySelector('[data-size="'+e.detail.blockId+'"]')?.click()})}})}

  } catch(e) { console.error(e); }
})();
})();
